export default {
  br: 'proposta-gympass',
  us: 'gympass-proposal',
  uk: 'gympass-proposal',
}
